import { useRouter } from "next/router";
import {
  Page,
  Layout,
  Banner,
  Link,
  Card,
  Tabs,
  Checkbox,
  Popover,
  Loading,
  ContextualSaveBar,
  TextStyle,
  Icon,
  Heading,
  Select,
  TextField,
  Tooltip,
  Text,
} from "@shopify/polaris";
import CustomWidget from "../../../components/widget-design/custom-widget.js";
import StyleAccordion from "../../../components/widget-design/style-accordion";
import WidgetPreview from "../../../components/widget-preview";
import Translations from "../../../components/widget-design/translations.js";

import Skeleton from "../../../components/skeleton";
import UpgradeTooltip from "../../../components/upgrade-tooltip";
import { LockMajor, CircleInformationMajor } from "@shopify/polaris-icons";

import { useCallback, useEffect, useState } from "react";
import { useAxios } from "../../../hooks/useAxios";
import {
  readSettings,
  updateSettings,
  readTranslations,
  updateWidgetTranslation,
  readCustomWidget,
} from "../../../utils/queries";

import { useLoopAuth } from "../../../components/user-provider"
import { userPermissionAccessType, permission } from "../../../utils/constants";
import AccessDenied from "../../../pages/access-denied";

function WidgetDesignSettings({
  shopOrigin,
  scopes,
  hasFeature,
  getMinPlanForFeature,
  ...props
}) {
  const router = useRouter();
  const [axios] = useAxios(props.axiosErrorHandle);
  const { validateUserPermission, user } = useLoopAuth();
  const title = "Widget Design";
  const subtitle =
    "Make modifications to your widget appearance and drive higher subscription conversions";

  const tabsOptions = [
    {
      id: "setting",
      content: "Settings",
    },
    {
      id: "translations",
      content: "Translations",
    },
    {
      id: "styles",
      content: "Styles",
    },
  ];

  const tabsWidgetOptions = [
    {
      id: "standard-widget",
      content: "Standard widget",
    },
    {
      id: "custom-widget",
      content: "Custom widget",
    },
  ];
  const [widgetTabs, setwidgetTabs] = useState(tabsWidgetOptions);
  const [selectedWidget, setselectedWidget] = useState(
    Number(router.query.tab || 0)
  );
  const handleWidgetTabChange = useCallback(
    (selectedTabIndex) => setselectedWidget(selectedTabIndex),
    []
  );

  const [tabs, settabs] = useState(tabsOptions);
  const [isDirty, setisDirty] = useState(false);
  const [selectedElement, setselectedElement] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [validVersion, setvalidVersion] = useState(false);
  const [displayWarningBanner, setdisplayWarningBanner] = useState(true);
  const [openedPanelId, setopenedPanelId] = useState(null);
  const [themeWithCustomWidget, setthemeWithCustomWidget] = useState([]);
  const [selected, setSelected] = useState(
    Number(router.query.standardWidget || 0)
  );
  const [widgetSetting, setwidgetSetting] = useState([]);
  const hasWidgetReadAccess = validateUserPermission(permission.WIDGET, userPermissionAccessType.READ);
  const hasWidgetWriteAccess = validateUserPermission(permission.WIDGET, userPermissionAccessType.WRITE);
  const [
    widgetSubscriptionOnlySetting,
    setwidgetSubscriptionOnlySetting,
  ] = useState([]);
  const [widgetStyleSetting, setwidgetStyleSetting] = useState([]);

  const [iniWidgetSetting, setiniWidgetSetting] = useState([]);
  const [
    iniWidgetSubscriptionOnlySetting,
    setiniWidgetSubscriptionOnlySetting,
  ] = useState([]);
  const [iniWidgetStyleSetting, setiniwidgetStyleSetting] = useState([]);
  const showInitialData = () => {
    setisDirty(false);
    setwidgetSetting(JSON.parse(JSON.stringify(iniWidgetSetting)));
    setwidgetSubscriptionOnlySetting(
      JSON.parse(JSON.stringify(iniWidgetSubscriptionOnlySetting))
    );
    setwidgetStyleSetting(JSON.parse(JSON.stringify(iniWidgetStyleSetting)));
    settranslations(inTranslations);
  };

  const [translations, settranslations] = useState([]);
  const [inTranslations, setinTranslations] = useState([]);
  const [scrollHeight, setscrollHeight] = useState(0);
  const listenToScroll = () => {
    setscrollHeight(document.documentElement.scrollTop);
  };
  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
  }, []);

  const loadCustomWidget = async () => {
    const { data } = await axios.post(
      `${process.env.HOST}/script_tags/get_themes`,
      {
        shop: shopOrigin,
      }
    );
    let themes = data?.themes;
    let res = await readCustomWidget(axios, {});
    let themeName = [];
    if (res?.customWidgets) {
      let cw = res?.customWidgets || [];
      cw.map((c) => {
        let theme = themes.find((t) => t.id === Number(c.theme_id));
        if (theme && c.active) {
          themeName.push(theme.name);
        }
      });
      setthemeWithCustomWidget(themeName);
      setdisplayWarningBanner(themeName && themeName.length > 0);
    }
    return themeName && themeName.length > 0;
  };

  const loadSettings = async () => {
    setisLoading(true);

    const res = await readSettings(axios, shopOrigin, "WIDGET", "ALL");
    const data = res.data;
    let translationsResponse = await readTranslations(axios, "WIDGET");
    settranslations(translationsResponse?.data?.translations || []);
    setinTranslations(translationsResponse?.data?.translations || []);

    let widgetSetting = data.preferences.filter(
      (setting) => setting.type === "ADMIN"
    );

    let widgetSubscriptionOnlySetting = data.preferences.filter(
      (setting) => setting.type === "SUBSCRIPTION_ONLY_PRODUCT"
    );

    let widgetStyleSetting = data.preferences.filter(
      (setting) => setting.type === "STYLE"
    );

    setwidgetSetting(
      widgetSetting.sort((a, b) => (a.order > b.order ? 1 : -1))
    );
    setwidgetSubscriptionOnlySetting(
      widgetSubscriptionOnlySetting.sort((a, b) => (a.order > b.order ? 1 : -1))
    );
    setwidgetStyleSetting(
      widgetStyleSetting.sort((a, b) => (a.order > b.order ? 1 : -1))
    );
    setiniWidgetSetting(
      JSON.parse(
        JSON.stringify(
          widgetSetting.sort((a, b) => (a.order > b.order ? 1 : -1))
        )
      )
    );
    setiniWidgetSubscriptionOnlySetting(
      JSON.parse(
        JSON.stringify(
          widgetSubscriptionOnlySetting.sort((a, b) =>
            a.order > b.order ? 1 : -1
          )
        )
      )
    );
    setiniwidgetStyleSetting(
      JSON.parse(
        JSON.stringify(
          widgetStyleSetting.sort((a, b) => (a.order > b.order ? 1 : -1))
        )
      )
    );
    setisLoading(false);
  };

  const saveWidgetDesignSettings = async () => {
    setisLoading(true);
    try {
      let resTrans = updateWidgetTranslation(axios, {
        translations,
      });

      let data = {
        myshopify_domain: shopOrigin,
        preferences: [
          ...widgetSetting,
          ...widgetSubscriptionOnlySetting,
          ...widgetStyleSetting,
        ],
      };
      let res = await updateSettings(axios, data);
    } catch (e) {
      console.log(e);
    }

    setisLoading(false);
    setisDirty(false);
  };

  useEffect(() => {
    if (router.query) {
      if (Number(router.query.tab) !== selectedWidget) {
        setselectedWidget(Number(router.query.tab) || 0);
      }
      if (Number(router.query.standardWidget) !== selected) {
        setSelected(Number(router.query.standardWidget) || 0);
      }
    }
  }, [router]);

  useEffect(() => {
    if (selectedWidget === 0) {
      router.push(
        `/settings/widget-design?tab=${selectedWidget}&standardWidget=${selected}`,
        `/settings/widget-design?tab=${selectedWidget}&standardWidget=${selected}`,
        {
          shallow: true,
        }
      );
    } else {
      router.push(
        `/settings/widget-design?tab=${selectedWidget}`,
        `/settings/widget-design?tab=${selectedWidget}`,
        {
          shallow: true,
        }
      );
    }
  }, [selectedWidget, selected]);

  const contextualSaveBar = isDirty ? (
    <ContextualSaveBar
      alignContentFlush={true}
      message="Unsaved changes"
      fullWidth
      saveAction={{
        content: "Save",
        onAction: saveWidgetDesignSettings,
      }}
      discardAction={{
        content: "Discard",
        onAction: showInitialData,
        disabled: isLoading,
      }}
    />
  ) : null;

  const banner = validVersion ? (
    <div style={{ marginBottom: "20px" }}>
      <Banner
        status="warning"
        title="Update Loop Snippet"
        onDismiss={() => {
          setvalidVersion(false);
        }}
      >
        <p>
          Widget design settings are supported only for Loop snippets V4.0 and
          higher. Please update your Loop snippet version by going to{" "}
          <Link
            onClick={() => {
              router.push("/widget-installation", "/widget-installation", {
                shallow: true,
              });
            }}
          >
            widget installation
          </Link>{" "}
          page and clicking on "Install Loop Snippet" button.
        </p>
      </Banner>
    </div>
  ) : null;

  const warningBanner =
    displayWarningBanner && selectedWidget === 0 ? (
      <div style={{ margin: "0 0 20px 0" }}>
        <Banner status="warning" title="">
          <p>
            Standard widget configurations will not be applied on{" "}
            <strong>{themeWithCustomWidget.join(", ") || "some"}</strong> theme
            {themeWithCustomWidget && themeWithCustomWidget.length > 1
              ? "s"
              : ""}
            , as you have activated custom widget.
          </p>
        </Banner>
      </div>
    ) : null;

  useEffect(() => {
    (async () => {
      setisLoading(true);
      let check = await loadCustomWidget();
      // if (check) {
      //   setselectedWidget(1);
      // }
      await loadSettings();
    })();
  }, []);

  useEffect(() => {
    if (!hasFeature("widget_style")) {
      tabsOptions[2].content = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ marginRight: "12px" }}>Styles</div>
          <div style={{ height: "16px" }}>
            <UpgradeTooltip plan={getMinPlanForFeature("widget_style")} />
          </div>
        </div>
      );
      settabs(tabsOptions);
    }

    if (!hasFeature("custom_widget")) {
      tabsWidgetOptions[1].content = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ marginRight: "12px" }}>Custom widget</div>
          <div style={{ height: "16px" }}>
            <UpgradeTooltip plan={getMinPlanForFeature("custom_widget")} />
          </div>
        </div>
      );
      setwidgetTabs(tabsWidgetOptions);
    }
  }, []);

  useEffect(() => {
    if (props?.snippet_version) {
      setvalidVersion(Number(props.snippet_version) < 4);
    }
  }, [props.snippet_version]);

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );

  const handleTextFieldChange = (index, val) => {
    let wSetting = widgetSetting.slice();
    if (wSetting[index].input_type == "INT") {
      wSetting[index].input_value_int = val;
    } else if (wSetting[index].input_type == "FLOAT") {
      wSetting[index].input_value_float = val;
    } else {
      wSetting[index].input_value_string = val;
    }
    setwidgetSetting(wSetting);
    setisDirty(true);
  };

  const handleChildPrefTextFieldChange = (index, val) => {
    let wSetting = widgetSetting.slice();
    wSetting[index].child_pref_value_string = val;
    setwidgetSetting(wSetting);
    setisDirty(true);
  };

  const handleCssChange = (index, val) => {
    let wSetting = widgetStyleSetting.slice();
    if (wSetting[index].input_type == "STRING") {
      wSetting[index].input_value_string = val;
    }
    setwidgetStyleSetting(wSetting);
    setisDirty(true);
  };

  const handleWidgetStyleChange = (index, val) => {
    let wSetting = widgetStyleSetting.slice();
    if (wSetting[index].input_type == "JSON") {
      wSetting[index].input_value_json = val;
    }
    setwidgetStyleSetting(wSetting);
    setisDirty(true);
  };

  const handleDropdownChange = (index, val) => {
    let wSetting = widgetSetting.slice();
    if (wSetting[index].input_type == "INT") {
      wSetting[index].input_value_int = val;
    } else if (wSetting[index].input_type == "FLOAT") {
      wSetting[index].input_value_float = val;
    } else {
      wSetting[index].input_value_string = val;
    }
    setwidgetSetting(wSetting);
    setisDirty(true);
  };

  const handleCheckBoxChange = (index, val) => {
    let wSetting = widgetSetting.slice();
    wSetting[index].is_enabled = val ? 1 : 0;
    setwidgetSetting(wSetting);
    setisDirty(true);
  };

  const scrollToTop = ({ index }) => {
    let scrollableElement = null;
    scrollableElement = document.querySelector("#stylecontainer");
    let children = scrollableElement.children;
    let total = 0;
    if (children && children.length) {
      for (let i = 0; i < children.length; i++) {
        let child = children[i];
        if (index > i) {
          total = total + 61;
        }
      }
    }
    setTimeout(() => {
      scrollableElement.scroll({
        top: total,
        behavior: "smooth",
      });
    }, 400);
  };

  const handleCheckBoxChangeForSubscriptionOnly = (index, val) => {
    let wSetting = widgetSubscriptionOnlySetting.slice();
    wSetting[index].is_enabled = val ? 1 : 0;
    setwidgetSubscriptionOnlySetting(wSetting);
    setisDirty(true);
  };

  function CardTitle({ title, content, showLock }) {
    const [popoverActive, setPopoverActive] = useState(false);

    const togglePopoverActive = useCallback(
      () => setPopoverActive((popoverActive) => !popoverActive),
      []
    );

    const activator = (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span
          onClick={togglePopoverActive}
          style={{
            cursor: "pointer",
            marginRight: "12px",
            height: "14px",
          }}
        >
          {title}
        </span>
        {showLock ? (
          <span>
            <div style={{ height: "16px" }}>
              <Tooltip
                active={false}
                content="Upgrade to a paid plan to use this feature"
              >
                <Icon source={LockMajor} color="success" />
              </Tooltip>
            </div>
          </span>
        ) : null}
      </div>
    );

    return (
      <div>
        <Popover
          preferredAlignment="left"
          active={popoverActive}
          activator={activator}
          onClose={togglePopoverActive}
        >
          <div style={{ maxWidth: "250px", padding: "10px" }}>{content}</div>
        </Popover>
      </div>
    );
  }

  if (isLoading) {
    return (
      <>
        <Loading />
        <Skeleton />
      </>
    );
  }

  return (
    <>
    {
    !hasWidgetReadAccess ? <AccessDenied userEmail = {user.email}/> : 
    <Page title={title} subtitle={subtitle}>
      {contextualSaveBar}
      {banner}

      <Tabs
        tabs={widgetTabs}
        selected={selectedWidget}
        onSelect={handleWidgetTabChange}
      >
        <br />
        {selectedWidget === 0 ? (
          <div>
            <Text color="subdued">
              Style and configure your subscription widget using our no-code
              editor.{" "}
              <Link
                external={true}
                url="https://learn.loopwork.co/en/article/100-widget-designs-w67gkw/"
              >
                Learn more
              </Link>
            </Text>
            <br />
            {warningBanner}
            <Layout>
              <Layout.Section oneHalf>
                <Card>
                  <Tabs
                    tabs={tabs}
                    selected={selected}
                    onSelect={handleTabChange}
                    fitted
                  >
                    {selected === 0 ? (
                      <div
                        style={{
                          overflow: "auto",
                          margin: "0 -20px",
                          padding: "0 20px",
                        }}
                      >
                        {widgetSetting.map((item, index) => {
                          let _input = null;
                          let _value = null;
                          let _childValue =
                            item.child_pref_value_string || null;

                          if (item.input_type == "INT")
                            _value = parseInt(item.input_value_int);
                          else if (item.input_type == "FLOAT")
                            _value = parseFloat(item.input_value_float);
                          else _value = item.input_value_string;
                          if (
                            item.input_element == "INPUT" &&
                            item.key === "discount-badge-widget-setting"
                          ) {
                            let checkboxFeild = null,
                              textboxField = null;

                            if (
                              !(
                                item.is_enabled === null ||
                                item.is_enabled === undefined
                              )
                            ) {
                              checkboxFeild = (
                                <div style={{ display: "flex" }}>
                                  <Checkbox
                                    label={<TextStyle>{item.name}</TextStyle>}
                                    checked={item.is_enabled == 1}
                                    disabled={props.snippet_version < 4.6 || !hasWidgetWriteAccess}
                                    onChange={(val) => {
                                      handleCheckBoxChange(index, val);
                                    }}
                                  />
                                  <div
                                    style={{
                                      marginLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {props.snippet_version < 4.6 ? (
                                      <CardTitle
                                        title={
                                          <Icon
                                            source={CircleInformationMajor}
                                            color="critical"
                                          />
                                        }
                                        content={
                                          <div>
                                            This feature is available only for
                                            Loop snippet V4.6 or above.
                                            <span
                                              style={{
                                                color: "#2c6ecb",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                router.push(
                                                  "/widget-installation",
                                                  "/widget-installation",
                                                  { shallow: true }
                                                );
                                              }}
                                            >
                                              {" "}
                                              Click here to update to latest
                                              version.{" "}
                                            </span>
                                          </div>
                                        }
                                      />
                                    ) : null}
                                  </div>
                                </div>
                              );
                            }

                            textboxField = (
                              <div
                                style={{
                                  width: "600px",
                                  maxWidth: "100%",
                                }}
                              >
                                <div style={{ marginLeft: "28px" }}>
                                  <TextField
                                    label=""
                                    value={_value}
                                    disabled={
                                      !item.is_enabled ||
                                      props.snippet_version < 4.6
                                      || !hasWidgetWriteAccess
                                    }
                                    onChange={(_newValue) =>
                                      handleTextFieldChange(index, _newValue)
                                    }
                                    autoComplete="off"
                                  />
                                </div>

                                <TextStyle variation="subdued">
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginTop: "8px",
                                    }}
                                  >
                                    {item.description}
                                  </div>
                                </TextStyle>
                              </div>
                            );

                            _input = (
                              <Card.Section key={index}>
                                {checkboxFeild}
                                {textboxField}
                              </Card.Section>
                            );
                          }
                          if (
                            item.input_element == "INPUT" &&
                            item.key === "subscription-details-popup"
                          ) {
                            let checkboxFeild = null,
                              textboxField = null;

                            if (
                              !(
                                item.is_enabled === null ||
                                item.is_enabled === undefined
                              )
                            ) {
                              checkboxFeild = (
                                <div style={{ display: "flex" }}>
                                  <Checkbox
                                    label={
                                      <TextStyle variation="strong">
                                        {item.name}
                                      </TextStyle>
                                    }
                                    checked={item.is_enabled == 1}
                                    disabled={props.snippet_version < 4.9 || !hasWidgetWriteAccess}
                                    onChange={(val) => {
                                      handleCheckBoxChange(index, val);
                                    }}
                                  />
                                  <div
                                    style={{
                                      marginLeft: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {props.snippet_version < 4.9 ? (
                                      <CardTitle
                                        title={
                                          <Icon
                                            source={CircleInformationMajor}
                                            color="critical"
                                          />
                                        }
                                        content={
                                          <div>
                                            This feature is available only for
                                            Loop snippet V4.9 or above.
                                            <span
                                              style={{ color: "#2c6ecb" }}
                                              onClick={() => {
                                                router.push(
                                                  "/widget-installation",
                                                  "/widget-installation",
                                                  { shallow: true }
                                                );
                                              }}
                                            >
                                              {" "}
                                              Click here to update to latest
                                              version.{" "}
                                            </span>
                                          </div>
                                        }
                                      />
                                    ) : null}
                                  </div>
                                </div>
                              );
                            }

                            textboxField = (
                              <div
                                style={{
                                  width: "600px",
                                  maxWidth: "100%",
                                }}
                              >
                                <div style={{ marginLeft: "28px" }}>
                                  <TextStyle>
                                    <div
                                      style={{
                                        marginTop: "8px",
                                        marginBottom: "8px",
                                        width: "600px",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      Label
                                    </div>
                                  </TextStyle>
                                  <TextField
                                    label=""
                                    value={_value}
                                    disabled={
                                      !item.is_enabled ||
                                      props.snippet_version < 4.6
                                      || !hasWidgetWriteAccess
                                    }
                                    onChange={(_newValue) =>
                                      handleTextFieldChange(index, _newValue)
                                    }
                                    autoComplete="off"
                                  />

                                  <TextStyle>
                                    <div
                                      style={{
                                        marginTop: "8px",
                                        marginBottom: "8px",
                                        width: "600px",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      Description
                                    </div>
                                  </TextStyle>
                                  <TextField
                                    label=""
                                    multiline={5}
                                    value={_childValue}
                                    disabled={
                                      !item.is_enabled ||
                                      props.snippet_version < 4.6
                                      || !hasWidgetWriteAccess
                                    }
                                    onChange={(_newValue) => {
                                      handleChildPrefTextFieldChange(
                                        index,
                                        _newValue
                                      );
                                    }}
                                    autoComplete="off"
                                  />
                                </div>

                                <TextStyle variation="subdued">
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginTop: "8px",
                                    }}
                                  >
                                    {item.description}
                                  </div>
                                </TextStyle>
                              </div>
                            );

                            _input = (
                              <Card.Section
                                key={index}
                                onMouseEnter={() => {
                                  setselectedElement(index);
                                }}
                                onMouseLeave={() => {
                                  setselectedElement(null);
                                }}
                              >
                                {checkboxFeild}
                                {textboxField}
                              </Card.Section>
                            );
                          } else if (
                            item.input_element == "INPUT" &&
                            !(
                              item.is_enabled === null ||
                              item.is_enabled === undefined
                            )
                          ) {
                            let checkboxFeild = null,
                              textboxField = null;
                            if (
                              !(
                                item.is_enabled === null ||
                                item.is_enabled === undefined
                              )
                            ) {
                              checkboxFeild = (
                                <Checkbox
                                  label={
                                    <TextStyle variation="strong">
                                      {" "}
                                      {item.name}{" "}
                                    </TextStyle>
                                  }
                                  checked={item.is_enabled == 1}
                                  onChange={(val) => {
                                    handleCheckBoxChange(index, val);
                                  }}
                                  disabled = {!hasWidgetWriteAccess}
                                />
                              );
                            }

                            textboxField = (
                              <div
                                style={{
                                  marginLeft: "28px",
                                  width: "calc(600px - 28px)",
                                  maxWidth: "calc(100% - 28px)",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={_value}
                                  onChange={(_newValue) =>
                                    handleTextFieldChange(index, _newValue)
                                  }
                                  autoComplete="off"
                                  disabled = {!hasWidgetWriteAccess}
                                />
                              </div>
                            );
                            if (
                              item.key === "purchase_option_label_setting" &&
                              !item.is_enabled
                            ) {
                              textboxField = null;
                            }

                            _input = (
                              <Card.Section
                                key={index}
                                onMouseEnter={() => {
                                  setselectedElement(index);
                                }}
                                onMouseLeave={() => {
                                  setselectedElement(null);
                                }}
                              >
                                {checkboxFeild}
                                {textboxField}
                              </Card.Section>
                            );
                          } else if (item.input_element == "INPUT") {
                            _input = (
                              <Card.Section key={index}>
                                <TextStyle variation="strong">
                                  <div
                                    style={{
                                      marginTop: "8px",
                                      marginBottom: "8px",
                                      width: "600px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                </TextStyle>
                                <TextField
                                  label=""
                                  value={_value}
                                  onChange={(_newValue) =>
                                    handleTextFieldChange(index, _newValue)
                                  }
                                  disabled = {!hasWidgetWriteAccess}
                                  autoComplete="off"
                                />
                              </Card.Section>
                            );
                          } else if (item.input_element == "DROPDOWN") {
                            _input = (
                              <Card.Section
                                key={index}
                                onMouseEnter={() => {
                                  setselectedElement(index);
                                }}
                                onMouseLeave={() => {
                                  setselectedElement(null);
                                }}
                              >
                                <TextStyle variation="strong">
                                  <div
                                    style={{
                                      marginBottom: "8px",
                                      width: "600px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                </TextStyle>
                                <Select
                                  options={item.input_options}
                                  value={_value}
                                  onChange={(_newValue) =>
                                    handleDropdownChange(index, _newValue)
                                  }
                                  disabled = {!hasWidgetWriteAccess}
                                />
                              </Card.Section>
                            );
                          } else {
                            _input = (
                              <Card.Section
                                key={index}
                                onMouseEnter={() => {
                                  setselectedElement(index);
                                }}
                                onMouseLeave={() => {
                                  setselectedElement(null);
                                }}
                              >
                                <Checkbox
                                  label={item.name}
                                  checked={item.is_enabled == 1}
                                  onChange={(val) => {
                                    handleCheckBoxChange(index, val);
                                  }}
                                  disabled = {!hasWidgetWriteAccess}
                                />
                                <br />
                                <TextStyle variation="subdued">
                                  <div style={{ marginLeft: "28px" }}>
                                    {item.description}
                                  </div>
                                </TextStyle>
                              </Card.Section>
                            );
                          }

                          return _input;
                        })}
                        <div style={{ borderBottom: "1px solid #ccc" }}></div>
                        <br />
                        <br />
                        <div style={{ marginLeft: "20px" }}>
                          <Heading>For subscription only products</Heading>
                        </div>
                        <br />
                        <div style={{ borderBottom: "1px solid #ccc" }}></div>
                        {widgetSubscriptionOnlySetting.map((item, index) => {
                          let _input = null;
                          let _value = null;

                          if (item.input_type == "INT")
                            _value = parseInt(item.input_value_int);
                          else if (item.input_type == "FLOAT")
                            _value = parseFloat(item.input_value_float);
                          else _value = item.input_value_string;

                          _input = (
                            <Card.Section
                              key={index}
                              onMouseEnter={() => {
                                setselectedElement(100 + index);
                              }}
                              onMouseLeave={() => {
                                setselectedElement(null);
                              }}
                            >
                              <Checkbox
                                label={item.name}
                                checked={item.is_enabled == 1}
                                onChange={(val) => {
                                  handleCheckBoxChangeForSubscriptionOnly(
                                    index,
                                    val
                                  );
                                }}
                                disabled = {!hasWidgetWriteAccess}
                              />
                              <br />
                              <TextStyle variation="subdued">
                                <div style={{ marginLeft: "28px" }}>
                                  {item.description}
                                </div>
                              </TextStyle>
                            </Card.Section>
                          );

                          return _input;
                        })}
                      </div>
                    ) : null}
                    {selected === 1 ? (
                      <div>
                        <Translations
                          translations={translations}
                          snippet_version={props.snippet_version}
                          changeInTranslations={(data) => {
                            settranslations(data);
                            setisDirty(true);
                          }}
                          hasWidgetWriteAccess = {hasWidgetWriteAccess}
                        />
                      </div>
                    ) : null}

                    <fieldset style={{padding: 0, margin: 0, border: 0}} disabled = {!hasWidgetWriteAccess}>
                    {selected === 2 ? (
                      <Card.Section>
                        <div
                          id="stylecontainer"
                          style={{
                            height: "600px",
                            overflow: "auto",
                            margin: "0 -20px",
                            padding: "0 20px",
                          }}
                        >
                          {widgetStyleSetting.map((item, index) => {
                            let _element = null;
                            _element = (
                              <StyleAccordion
                                key={index}
                                index={index}
                                item={item}
                                name={item.name}
                                open={openedPanelId === index}
                                hasFeature={hasFeature}
                                getMinPlanForFeature={getMinPlanForFeature}
                                disabled={
                                  item.key == "edit_css_classes"
                                    ? !hasFeature("edit_css_classes")
                                    : !hasFeature("widget_style")
                                }
                                options={
                                  item.input_options ? item.input_options : []
                                }
                                input_value_json={
                                  item.input_value_json
                                    ? item.input_value_json
                                    : {}
                                }
                                input_value_string={
                                  item.input_value_string
                                    ? item.input_value_string
                                    : ""
                                }
                                handleOpenClose={(index) => {
                                  if (openedPanelId === index) {
                                    setopenedPanelId(null);
                                  } else {
                                    setopenedPanelId(index);
                                    scrollToTop({ index });
                                  }
                                }}
                                handleChange={(val) => {
                                  handleWidgetStyleChange(index, val);
                                }}
                                handleCssChange={(val) => {
                                  handleCssChange(index, val);
                                }}
                              />
                            );

                            return _element;
                          })}
                        </div>
                      </Card.Section>
                    ) : null}
                    </fieldset>
                  </Tabs>
                </Card>
              </Layout.Section>
              <Layout.Section secondary oneHalf>
                <div
                  style={
                    scrollHeight > 200
                      ? {
                          position: "fixed",
                          top: "56px",
                          width: "470px",
                        }
                      : {}
                  }
                >
                  <WidgetPreview
                    selectedElement={selectedElement}
                    openedPanelId={openedPanelId}
                    widgetSetting={widgetSetting}
                    widgetSubscriptionOnlySetting={
                      widgetSubscriptionOnlySetting
                    }
                    widgetStyleSetting={widgetStyleSetting}
                    translations={translations}
                    redirectToPlan={() => {
                      router.push("/settings/pricing", "/settings/pricing", {
                        shallow: true,
                      });
                    }}
                  />
                </div>
              </Layout.Section>
            </Layout>
          </div>
        ) : null}
        <fieldset style={{margin: 0, padding: 0, border: 0}} disabled = {!hasWidgetWriteAccess}>
        {selectedWidget === 1 ? (
          <CustomWidget
            shopOrigin={shopOrigin}
            hasFeature={hasFeature}
            getMinPlanForFeature={getMinPlanForFeature}
            snippet_version={props.snippet_version}
            refreshedData={() => {
              loadCustomWidget();
            }}
          />
        ) : null}
        </fieldset>
      </Tabs>
    </Page>
    }
    </>
  );
}
export default WidgetDesignSettings;
